import { Component, Input, OnInit, TemplateRef, ViewChild, inject } from '@angular/core';
import { SharedModule } from '@shared/shared.module';
import { RapidReviewDiagnosisComponent } from '@shared/component/rapid-review-modal/rapid-review-diagnosis/rapid-review-diagnosis.component';
import {
	RapidReviewAcuityFieldFormattedResponse,
	RapidReviewHistoryFormattedResponse,
	RapidReviewModalService
} from '@shared/component/rapid-review-modal/rapid-review-modal.service';
import { GridUtil, RevColDef } from 'majora';

@Component({
	selector: 'pms-rapid-review-history',
	imports: [SharedModule, RapidReviewDiagnosisComponent],
	templateUrl: './rapid-review-history.component.html',
})
export class RapidReviewHistoryComponent implements OnInit {
	private rapidReviewModalService = inject(RapidReviewModalService);

	@Input({required: true})
	encounterId: number;

	@ViewChild('visualAcuityTemplate')
	visualAcuityTemplate!: TemplateRef<any>;

	history: RapidReviewHistoryFormattedResponse;
	gridColumns: RevColDef<RapidReviewAcuityFieldFormattedResponse>[] = [
		GridUtil.buildColumn('', 'fieldName', {sortable: false}),
		GridUtil.buildFieldTemplateColumn('Uncorrected Visual Acuity', 'uncorrected', () => this.visualAcuityTemplate, {sortable: false}),
		GridUtil.buildFieldTemplateColumn('Aided Visual Acuity', 'aided', () => this.visualAcuityTemplate, {flex: 1, sortable: false}),
	];

	ngOnInit(): void {
		this.rapidReviewModalService.getRapidReviewHistory(this.encounterId).subscribe(response => this.history = response);
	}
}
